import { render, staticRenderFns } from "./DetailUser.vue?vue&type=template&id=312b8ff9"
import script from "./DetailUser.vue?vue&type=script&lang=js"
export * from "./DetailUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports